// A stored zero does not prove a free request or a zero provider invoice.
export function costText(value) {
  const cost=Number(value);
  if (!Number.isFinite(cost)||cost<=0) return 'برآورد موجود نیست';
  if (cost<0.000001) return '< $0.000001';
  return `$${cost.toFixed(cost<0.001?6:cost<0.1?5:4)}`;
}
